<section class="banner">
  <div class="banner-grid">
    @for (bannerItem of banner(); track bannerItem.id; let i = $index) {
      <a
        class="banner-item banner-item-{{i}}"
        [routerLink]="'/' + bannerItem.slug"
        routerLinkWithLang
      >
        <ng-container *ngTemplateOutlet="bannerItemTmpl; context: { bannerItem: bannerItem }"></ng-container>
      </a>
    }
  </div>
</section>

@if (banner().length) {
  <div class="slider">
    <carousel
      [carouselItems]="banner()"
      [itemsPerSlide]="itemsPerSlide"
      [autoSwipe]="true"
      [showThumbnails]="false"
    />
  </div>
}

<ng-template
  #bannerItemTmpl
  let-bannerItem="bannerItem"
>
  <img
    class="banner-img"
    [src]="setBannerItemSrc(bannerItem)"
    [alt]="bannerItem.slug"
  >

  @if (bannerItem?.price && !bannerItem?.oldPrice) {
    <div class="banner-sale-label sale-label">
      <span class="sale-label-price sale-label-price-black">{{ bannerItem?.price }} грн</span>
    </div>
  }

  @if (bannerItem?.oldPrice) {
    <div class="banner-sale-label sale-label">
      <span class="sale-label-old-price">{{ bannerItem?.oldPrice }} грн</span>
      <span class="sale-label-price sale-label-price-red">{{ bannerItem?.price }} грн</span>
    </div>
  }

  @if (bannerItem?.label) {
    <span
      class="banner-label"
      [class]="getLabelClass(bannerItem) ?? ''"
    >
      {{ bannerItem.label.text }}
    </span>
  }
</ng-template>
